
import React from 'react';
import { useSelector } from 'react-redux';
import { getAllProducts } from '../../features/productSlice/productSlice';
import { isDataLoaded } from '../../features/productSlice/productSlice';
import ProductCard from '../ProductCard/ProductCard'
import './ProductListing.scss';

const ProductListing = () => {
  
    const products = useSelector(getAllProducts);

     const dataLoaded = useSelector(isDataLoaded);
 if (dataLoaded==true) {


    return  <ProductCard data={products}/>
  
  };


  
  return (
        <div>
            Kindly wait! Store is loading...
        </div>
    );
};

export default ProductListing;